export function matchEnum<E extends Record<string, any>, T extends string>(obj: E, token: T): token is E[keyof E] {
    return Object.values(obj).includes(token as E[keyof E]);
}
